import { Loader2 } from "lucide-react";

/**
 * The one "scenario is computing" indicator, used everywhere a Scenario page waits on a
 * backend recompute — Apply's waterfall, Monitor, Capacity, Reconciliation. Circular, not the
 * Athena-branded flash icon Underwriting Engine uses for its own AI recommendation step:
 * Scenario isn't an AI feature, so borrowing that branding here would misrepresent what's
 * actually running (a real-vs-scenario limit recomputation, not a model call).
 */
export function ScenarioSpinner({ label }: { label: string }) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-2 py-12"
      aria-live="polite"
      aria-busy="true"
    >
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <p className="text-sm text-muted-foreground">{label}</p>
    </div>
  );
}
